<template lang="pug">
  b-navbar.is-main(fixed-top)

    template(v-slot:brand)
      router-link.navbar-item(to="/" exact)
        b-icon(v-if="breadcrumbs.length" icon="home")
        template(v-else) <b>Сфера</b> Обучение

      template(v-for="bc,index in breadcrumbs")
        span.navbar-item.is-current(v-if="bc.current" :key="index") {{bc.title}}
        router-link.navbar-item(v-else :to="bc.route" :key="index" exact) {{bc.title}}

    //- slot

    template(v-slot:end)
      //- .navbar-menu
      //- .navbar-end

      b-navbar-dropdown(right :active.sync="dropdownActive")
        template(v-slot:label)
          ui-avatar(:user="user")
          span {{ user.first_name }} {{ user.last_name }}

        div(@click="closeDropdown")
          b-navbar-item(tag="router-link" :to={name:'profile'})
            b-icon(icon="settings")
            span Профиль пользователя
          hr.dropdown-divider
          b-navbar-item(@click="$emit('logout')")
            b-icon(icon="logout")
            span Выход
</template>

<script>
export default {
  name: 'ui-navbar',

  props: {
    user: null,
    breadcrumbs: Array,
  },

  data: () => ({
    dropdownActive: false,
  }),

  methods: {
    closeDropdown() {
      this.dropdownActive = true;
      this.$nextTick(() => {
        this.dropdownActive = false;
      });
    },
  },

  // computed: {
  //   breadcrumbs() {
  //     let breadcrumbs = [];
  //     this.$route.matched.forEach(route => {
  //       if (route.meta && route.meta.breadcrumb) {
  //         const bc = route.meta.breadcrumb;

  //         breadcrumbs.push({
  //           title: typeof bc === 'function' ? bc.call(this, this.$route.params) : bc,
  //           route: { name: route.name, params: route.params },
  //         });
  //       }
  //     });
  //     return breadcrumbs;
  //   },
  // },
};
</script>
